export const PAGE = 0;
export const ROWS_PER_PAGE = 25;
export const ROWS_PER_PAGE_OPTION = [15, 25, 35];
